import { COSUPPORT_URL } from 'src/constants/urls';

export const OnboardingStep7Footer = () => {
  return (
    <div className={'w-full flex flex-row gap-7.5 items-center justify-center'}>
      <p className={'text-ebony_opacity_40 text-xs font-jamjuree'}>
        <a
          className={'underline hover:text-ebony'}
          href={COSUPPORT_URL.PRIVACY}
          target={'_blank'}
          rel="noreferrer"
        >
          Privacy Policy{' '}
        </a>{' '}
        &{' '}
        <a
          className={'underline hover:text-ebony'}
          href={COSUPPORT_URL.TERMS_OF_SERVICES}
          target={'_blank'}
          rel={'noreferrer'}
        >
          Terms of Service
        </a>
      </p>
    </div>
  );
};
